export default "__VITE_ASSET__C6EH$RuI__"